var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftSkillsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7011_8071)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7011_8071)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(2.5 2.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8744 12.7472C24.9568 12.6647 25.0031 12.553 25.0031 12.4365C25.0031 12.3199 24.9568 12.2081 24.8744 12.1257L22.8777 10.1287C22.7919 10.0429 22.6795 10 22.567 10C22.4546 10 22.3421 10.0429 22.2563 10.1287L20.5703 11.815L23.1884 14.4334L24.8744 12.7472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0314 24.3953C9.96617 24.5585 10.0044 24.7449 10.1287 24.8692C10.2127 24.9533 10.3251 24.998 10.4394 24.998C10.4943 24.998 10.5497 24.9877 10.6025 24.9665L13.6613 23.7427L11.2549 21.3359L10.0314 24.3953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7296 18.474C21.5344 18.474 21.3383 18.4914 21.1436 18.5271L16.4709 13.8535C16.6625 12.805 16.3287 11.7144 15.5696 10.955C14.9445 10.3299 14.1074 10.0001 13.2592 10C12.7831 10 12.3036 10.1039 11.8559 10.3177C11.7272 10.3792 11.6363 10.4993 11.6122 10.64C11.5881 10.7805 11.6337 10.9241 11.7346 11.025L13.3065 12.5972L12.5968 13.307L11.0247 11.7349C10.9416 11.6517 10.8295 11.6062 10.714 11.6061C10.6893 11.6061 10.6645 11.6082 10.6398 11.6125C10.4992 11.6366 10.3791 11.7275 10.3176 11.8562C9.72288 13.1019 9.97903 14.5946 10.955 15.5705C11.5732 16.1889 12.4111 16.5251 13.267 16.5251C13.4622 16.5251 13.6582 16.5076 13.8528 16.472L18.5256 21.1455C18.3339 22.194 18.6676 23.2845 19.4268 24.0439C20.052 24.6692 20.8891 24.999 21.7374 24.999C22.2134 24.999 22.693 24.8951 23.1406 24.6813C23.2693 24.6198 23.3602 24.4996 23.3843 24.359C23.4084 24.2184 23.3628 24.0749 23.2619 23.974L21.69 22.4018L22.3997 21.692L23.9715 23.2642C24.0546 23.3473 24.1666 23.3929 24.2822 23.3929C24.3069 23.3929 24.3317 23.3908 24.3564 23.3866C24.497 23.3625 24.6171 23.2716 24.6787 23.1429C25.2736 21.8973 25.0175 20.4045 24.0414 19.4284C23.4233 18.8101 22.5855 18.474 21.7296 18.474Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7734 20.6094L14.2618 18.1206L16.8795 20.7387L14.3911 23.2275L11.7734 20.6094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 14.2617L19.9479 12.4385L22.5656 15.0566L20.7427 16.8798L18.125 14.2617Z",
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 34.5,
    height: 34.5,
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7011_8071",
    x: 0.5,
    y: 2.5,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7011_8071"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.627451 0 0 0 0 0.698039 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7011_8071"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7011_8071",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7011_8071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftSkillsIcon);
export default __webpack_public_path__ + "static/media/softSkillsIcon.0474846ce157dee8752bd08ea248da0b.svg";
export { ForwardRef as ReactComponent };